import CssBaseline from "@mui/material/CssBaseline";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppRouter from "./routers/appRouter";
import { Container, Paper } from "@mui/material";
import "./App.css";

import OpenDyslexicRegular from "./fonts/OpenDyslexic-Regular.otf";
// import ThemeProvider from "./theme/index";

const theme = createTheme({
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    // fontSize: 12,
    fontFamily: "OpenDyslexicRegular, sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'OpenDyslexicRegular';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('OpenDyslexicRegular'), local('OpenDyslexicRegular'), url(${OpenDyslexicRegular});
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

export default function Checkout() {
  return (
    <ThemeProvider theme={createTheme()}>
      <CssBaseline />
      <Container component="main" maxWidth="xl" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <AppRouter />
        </Paper>
      </Container>
    </ThemeProvider>
  );
}
